<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- Six solid pieces; the meridian band and the equator are the gaps. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="none"
      d="M1.046 11A11 11 0 0 1 11.571 1.008A15.5 15.5 0 0 0 7.032 11zM9.037 11A13.5 13.5 0 0 1 12 3.515A13.5 13.5 0 0 1 14.963 11zM22.954 11A11 11 0 0 0 12.429 1.008A15.5 15.5 0 0 1 16.968 11zM1.046 13A11 11 0 0 0 11.571 22.992A15.5 15.5 0 0 1 7.032 13zM9.037 13A13.5 13.5 0 0 0 12 20.485A13.5 13.5 0 0 0 14.963 13zM22.954 13A11 11 0 0 1 12.429 22.992A15.5 15.5 0 0 0 16.968 13z"
    />
  </svg>
</template>
